import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { navigationService } from 'src/config/rootService';
import { CareRecommendationState } from 'src/generated/webapp_gql';
import { getMostRecentCareRecommendation } from 'src/modules/user/selectors/userSelectors';

import { Scores, SetOfAssessments } from '../components/SetOfAssessments';
import { FlowType } from '../models/assessments';

export const RetakeAssessmentsPage: React.FC = () => {
    const handleAssessmentSubmit = (scores: Scores) => {
        navigationService.navigate('/wellbeing-report', { score: scores.who5 });
    };
    const careRecommendation = useSelector(getMostRecentCareRecommendation);

    if (
        !careRecommendation ||
        careRecommendation?.state === CareRecommendationState.BypassedAssessments
    ) {
        return <Redirect to="/a-few-questions" />;
    }

    return (
        <SetOfAssessments
            onSubmit={handleAssessmentSubmit}
            flowType={FlowType.MEMBER_WEB_SETTINGS}
        />
    );
};
